import { AbstractControl, ValidationErrors } from '@angular/forms';

export abstract class NoWhitespaceValidator {
  // Matches any whitespace character
  private static readonly REGEX = /\s/;

  static noWhitespace(control: AbstractControl): ValidationErrors | null {
    const value = control?.value;
    if (value == null || value === '') return null; // let 'required' handle empties
    return typeof value === 'string' && NoWhitespaceValidator.REGEX.test(value) ? { spaceInUsername: { valid: false } } : null;
  }
}
